import { Button } from '@kovix/ui';
import { useEffect, useState } from 'react';
import { isStaleCallbackError, reauthenticate } from '@/app/auth/auth';

/** Lỗi đăng nhập OIDC (state đã dùng, cần đăng nhập lại) — thử đăng nhập lại thay vì hiện lỗi. */
const AUTH_ERROR = /login_required|interaction_required|invalid_grant/i;

/**
 * 12/10/2026 (staging: "Something went wrong! / Show Error" sau khi đăng nhập rồi bấm Back) — màn lỗi MẶC ĐỊNH của router: không lộ lỗi kỹ thuật cho
 * người dùng (chi tiết chỉ ghi console để hỗ trợ). Lỗi đăng nhập → reauthenticate() của shell-kit (nhớ trang đang xem, chốt 60 s chống vòng lặp);
 * chốt chặn đã chạm (vừa đăng nhập lại mà vẫn lỗi) → hiện màn lỗi.
 */
export function RouteErrorPage({ error, reset }: { error: unknown; reset?: (() => void) | undefined }) {
  const message = error instanceof Error ? error.message : String(error ?? '');
  const authError = isStaleCallbackError(error) || AUTH_ERROR.test(message);
  const [redirecting, setRedirecting] = useState(authError);
  useEffect(() => {
    console.error('[KOVIX] lỗi màn hình', error);
    if (authError && !reauthenticate()) setRedirecting(false);
  }, [error, authError]);
  if (redirecting) return null;
  return (
    <div style={{ display: 'grid', placeItems: 'center', minHeight: '60vh', padding: 24, textAlign: 'center' }}>
      <div style={{ maxWidth: 420 }}>
        <h2 style={{ marginBottom: 8 }}>Đã có lỗi khi tải trang</h2>
        <p style={{ color: 'var(--kx-muted)', marginBottom: 16 }}>
          Vui lòng thử lại. Nếu vẫn gặp lỗi, liên hệ quản trị viên để được hỗ trợ.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
          {reset ? (
            <Button variant="primary" onClick={reset}>
              Thử lại
            </Button>
          ) : null}
          <Button variant={reset ? undefined : 'primary'} onClick={() => window.location.reload()}>
            Tải lại trang
          </Button>
          <Button onClick={() => window.location.assign('/')}>Về trang chủ</Button>
        </div>
      </div>
    </div>
  );
}
